// extracted by mini-css-extract-plugin
export default {"EsimModal":"style_EsimModal__FN-9+","formGroup":"style_formGroup__WNvvC","error":"style_error__9eB6q"};